import type { RepCardData } from "../types";
import { track } from "../session";

// A sales rep rendered as a click-to-contact card. The tel:/mailto: links are
// the trackable conversion surface (rep_contact_click) — a real intent signal
// that the chat connected the visitor to a salesperson. tel:/mailto: aren't
// http(s) so they carry no attribution param; we capture the click directly.
export function RepCard({ rep }: { rep: RepCardData }) {
  return (
    <div class="rep-card">
      <div class="rep-card-head">
        <span class="rep-card-name">{rep.name}</span>
        {rep.subtitle && <span class="rep-card-sub">{rep.subtitle}</span>}
      </div>
      <div class="rep-card-actions">
        {rep.phone && (
          <a
            class="rep-card-action"
            href={`tel:${rep.phone.replace(/[^\d+]/g, "")}`}
            onClick={() =>
              track("rep_contact_click", rep.phone ?? undefined, {
                name: rep.name,
                channel: "phone",
              })
            }
          >
            Call {rep.phone}
          </a>
        )}
        {rep.email && (
          <a
            class="rep-card-action"
            href={`mailto:${rep.email}`}
            onClick={() =>
              track("rep_contact_click", rep.email ?? undefined, {
                name: rep.name,
                channel: "email",
              })
            }
          >
            Email
          </a>
        )}
        {rep.website && (
          <a
            class="rep-card-action"
            href={rep.website}
            target="_blank"
            rel="noopener"
            onClick={() =>
              track("rep_contact_click", rep.website ?? undefined, {
                name: rep.name,
                channel: "website",
              })
            }
          >
            Website
          </a>
        )}
      </div>
    </div>
  );
}
